import { render } from "./CryptoMarketCap.vue?vue&type=template&id=c4ee1dec&ts=true"
import script from "./CryptoMarketCap.vue?vue&type=script&lang=ts"
export * from "./CryptoMarketCap.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__